import '../styles/main.scss';
import 'svgxuse';
import smoothscroll from 'smoothscroll-polyfill';
import Util from './modules/Utilities';
import Header from './modules/Header';
import Menu from './modules/Menu';
import Sliders from './modules/Sliders';
import Animations from './modules/Animations';
import AsyncImage from './modules/AsyncImage';

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('loading');

  smoothscroll.polyfill();
  Util.forEachPolyfill();
  Util.anchorsInit();
  Util.addTargetBlank();

  new Header(document.querySelector('.header'));
  new Menu(document.querySelector('.menu'));
  new Animations();

  Sliders.heroSlider();
  Sliders.pointSliderOne();
  Sliders.pointSliderTwo();
});

window.onload = () => {
  const asyncImages = document.querySelectorAll('[data-src], [data-background]');
  asyncImages.forEach(el => new AsyncImage(el));
}

document.getElementById("acard-open").onclick = () => {
  document.getElementById("popup-acard").style.display = "block"
}

document.getElementById("popup-acard").onclick = () => {
  document.getElementById("popup-acard").style.display = "none"
}

document.getElementById("cycle-open").onclick = () => {
  document.getElementById("popup-cycle").style.display = "block"
}

document.getElementById("popup-cycle").onclick = () => {
  document.getElementById("popup-cycle").style.display = "none"
}

document.getElementById("acard-close").onclick = () => {
  document.getElementById("popup-acard").style.display = "none"
}

document.getElementById("cycle-close").onclick = () => {
  document.getElementById("popup-cycle").style.display = "none"
}
